import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Tooltip from "@mui/material/Tooltip";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED",
        },
        color: theme.palette.common.white,
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #E6E8ED",
        color: "#4A4A4A",
    },
}));

function GuidesComponents({openGuideDrawer, activeGuide}) {
    let classes = useStyles();
    return (
        <Tooltip
            classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
            title={<span className="text-[#1A1919] text-base">راهنما</span>}
            arrow
        >
            <div className="px-4 ">
                <button onClick={() => openGuideDrawer()} className="bg-white py-2  ">
                    <QuestionMarkIcon sx={{color: !activeGuide ? "#AEAEAE" : "#1062D0"}}/>
                </button>
            </div>
        </Tooltip>
    );
}

export default GuidesComponents;
